export enum LoadingStatus {
    None,
    Start,
    End,
    error,
}
